import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const subjects = [
  "Basic Electrical Engineering",
  "Engineering Graphics",
  "Engineering Mathematics",
  "Engineering Mechanics",
  "Engineering Physics",
  "Engineering Chemistry",
  "Fundamentals of Programming  Language"
];

function EfcSubjects() {

  const navigate = useNavigate();

  return (

    <Box sx={{ p: 2 }}>

      <Typography variant="h5" mb={2}>
        Engineering Foundation Course
      </Typography>

      {subjects.map((s) => (

        <Card
          key={s}
          sx={{
            p: 2,
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer"
          }}
          onClick={() =>
            navigate(`/efc-videos/${encodeURIComponent(s)}`)
          }
        >
          <Typography>{s}</Typography>
          <Typography>▶</Typography>
        </Card>

      ))}

    </Box>
  );
}

export default EfcSubjects;
